import { BlockOutlined, ChevronRight, DeleteSweepRounded, SearchRounded } from '@mui/icons-material';
import {
    Avatar,
    Button,
    ButtonGroup,
    CardContent,
    Chip,
    Grid,
    IconButton,
    ListItemAvatar,
    ListItemText,
    Pagination,
    Paper,
    Stack,
} from '@mui/material';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useFetch } from '../../../hooks/useFecth';
import DialogMigrate from '../../DialogMigrate';
import DialogAdvertiser from './components/DialogAdvertiser';
import { SearchDrawer } from './components/SearchDrawer';
import DialogOffer from './components/DialogOffer';
import useDialog from '../../../hooks/useDialog';
import SelectStoreLomadee from './components/SelectStoreLomadee';

export default function OfertasSocialSoul() {
    const [searchParams, setParams] = useSearchParams();
    const [brand, setBrand] = useState();
    const [campaign, setCampaign] = useState();
    const { handleOpen } = useDialog('offer');

    const { data, mutate } = useFetch(brand?.id ? 'brokers/lomadee/campaigns':null, { 
        params: { 
            ...Object.fromEntries(searchParams),
            organizationIds: brand?.id,
            type: 'Offer' // Filtrar apenas ofertas
        } 
    });

    const handleClearFilters = () => {
        setParams({});
    };
    

    const handlePage = (event, page) => {
        // Atualiza os parâmetros da URL, mantendo todos os outros e apenas mudando o parâmetro 'page'
        setParams(prevParams => {
            const newParams = new URLSearchParams(prevParams);
            newParams.set('page', page); // Define o número da página na URL
            return newParams;
        });
    };

    const openOfferSyncModal = campaign => {
        handleOpen();
        campaign && setCampaign(campaign);
    };

    const hasFilters = Array.from(searchParams.entries()).some(([key, value]) => value !== '' && value !== null);

    return (
        <Container maxWidth="xl">
            <Stack pb={2}>
                <Typography variant="h2">Ofertas - SocialSoul</Typography>
            </Stack>

            <Card>
                <CardContent>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12}>
                            <SelectStoreLomadee
                                value={brand?.id || ''}
                                name="brandId"
                                label="Selecione a marca para ver as ofertas"
                                onChange={selectedBrand => {
                                    setBrand(selectedBrand);
                                    setParams(prevParams => {
                                        const newParams = new URLSearchParams(prevParams);
                                        if (selectedBrand?.id) {
                                            newParams.set('organizationIds', selectedBrand.id);
                                        } else {
                                            newParams.delete('organizationIds');
                                        }
                                        newParams.set('page', 1);
                                        return newParams;
                                    });
                                }}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
                <Divider />

                <List size="md" sx={{ gap: 1 }}>
                    <>
                        {!Boolean(brand) && (
                            <Paper sx={{ p: 4, border: 0 }}>
                                <Stack direction="row" justifyContent="center" gap={1}>
                                    <Typography>Selecione uma marca para ver as ofertas.</Typography>
                                </Stack>
                            </Paper>
                        )}

                        {Boolean(brand) && data?.meta?.total === 0 && (
                            <Paper sx={{ p: 4, border: 0 }}>
                                <Stack direction="row" justifyContent="center" gap={1}>
                                    <Typography>Nenhuma oferta encontrada.</Typography>
                                    <BlockOutlined />
                                </Stack>
                            </Paper>
                        )}

                        {Boolean(brand) &&
                            data?.meta?.total > 0 &&
                            data?.campaigns
                                ?.filter(item => !data?.syncedCampaigns?.includes(item.id))
                                ?.map(item => (
                                    <React.Fragment key={`offer_item_${item.id}`}>
                                        <ListItem
                                            secondaryAction={
                                                <IconButton onClick={() => openOfferSyncModal(item)}>
                                                    <ChevronRight />
                                                </IconButton>
                                            }
                                        >
                                            <ListItemAvatar>
                                                <Avatar
                                                    src={item.image}
                                                    variant="rounded"
                                                    sx={{ border: '1px solid #eee', objectFit: 'cover', width: 50, height: 50 }}
                                                />
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={item.name || item.description || 'Oferta sem nome'}
                                                primaryTypographyProps={{ variant: 'title-md' }}
                                                secondary={
                                                    <Stack spacing={0.5} pt={0.5}>
                                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }} gutterBottom>
                                                            {item.description}
                                                        </Typography>
                                                        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{ mb: 0.5 }}>
                                                            <Chip size="small" label={`ID: ${item.id}`} />
                                                            {item.category?.name && <Chip size="small" label={item.category.name} />}
                                                            {item.price && (
                                                                <Chip
                                                                    size="small"
                                                                    label={`R$ ${item.price.toFixed(2)}`}
                                                                    color="primary"
                                                                    variant="filled"
                                                                />
                                                            )}
                                                            {item.priceFrom && item.priceFrom > (item.price || 0) && (
                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                    sx={{ textDecoration: 'line-through' }}
                                                                >
                                                                    R$ {item.priceFrom.toFixed(2)}
                                                                </Typography>
                                                            )}
                                                            {item.discountValue && (
                                                                <Chip size="small" label={`${item.discountValue}% OFF`} color="secondary" />
                                                            )}
                                                            {item.highlighted && <Chip size="small" label="Destaque" color="warning" />}
                                                        </Stack>
                                                        {item.validUntil && (
                                                            <Typography variant="caption" color="text.secondary">
                                                                Válido até: {new Date(item.validUntil).toLocaleDateString('pt-BR')}
                                                            </Typography>
                                                        )}
                                                    </Stack>
                                                }
                                            />
                                        </ListItem>
                                        <Divider />
                                    </React.Fragment>
                                ))}
                    </>
                </List>
                {Boolean(brand) && data?.meta?.total > 0 && (
                    <Stack direction="row" py={2} justifyContent="center">
                        <Pagination page={data?.meta?.page || 1} count={data?.meta?.totalPages || 1} onChange={handlePage} />
                    </Stack>
                )}
            </Card>

            <DialogOffer mutate={mutate} campaign={campaign} />
            <DialogAdvertiser mutate={mutate} coupon={campaign} />
        </Container>
    );
}
